import React from 'react';
import { View } from 'react-native';
const Triangle = ({ width = 12, height = 12, rotation = 0, color = 'black', style, }) => (<View style={[
        {
            width: 0,
            height: 0,
            borderLeftWidth: width / 2,
            borderRightWidth: width / 2,
            borderBottomWidth: height,
            borderLeftColor: 'transparent',
            borderRightColor: 'transparent',
            borderBottomColor: color ?? 'black',
            transform: [{ rotate: `${rotation}deg` }],
        },
        style,
    ]}/>);
export default Triangle;
